<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-form label-position="right" label-width="80px">
          <el-form-item :label="$t('advert.name')">
            <span class="grey_color">{{editorForm.adTitle}}</span>
          </el-form-item>
          <el-form-item :label="$t('advert.classify')">
            <!--<span class="grey_color">{{editorForm}}</span>-->
            <span class="grey_color" v-for="item in adTypeList" v-if="item.adtypeId === editorForm.adType">{{item.adtypeName}}</span>
          </el-form-item>
          <el-form-item :label="$t('advert.position')">
            <template>
              <span class="grey_color" v-if="editorForm.adPosition == 0">{{$t('advert.positionSub.banner')}}</span>
              <span class="grey_color" v-if="editorForm.adPosition == 1">{{$t('advert.positionSub.starPage')}}</span>
              <span class="grey_color" v-if="editorForm.adPosition == 3">{{$t('app_appadv')}}</span>
              <!--<span class="grey_color" v-if="editorForm.adPosition == 2">个人中心banner</span>-->
            </template>
          </el-form-item>

          <el-form-item :label="$t('advert.jumpType')">
            <span class="grey_color" v-if="editorForm.adUrltype == '0'">{{$t('advert.jumpTypeSub.net')}}</span>
            <span class="grey_color" v-if="editorForm.adUrltype == '1'">{{$t('advert.jumpTypeSub.appStore')}}</span>
          </el-form-item>

          <el-form-item v-if="editorForm.adUrltype === '1'" :label="$t('advert.app')" prop="ad_url">
            <span class="grey_color" >{{editorForm.appName}}</span>
          </el-form-item>

          <!-- 当跳转类型为跳转时,ad_url则输入跳转的url -->
          <el-form-item v-if="editorForm.adUrltype === '0'" :label="$t('advert.url')">
            <span class="grey_color" >{{editorForm.adUrl}}</span>
          </el-form-item>

          <!--<el-form-item label="跳转链接">-->
          <!--<span class="grey_color">{{editorForm.adUrl}}</span>-->
          <!--</el-form-item>-->
          <el-form-item :label="$t('advert.ableDate')">
            <span class="grey_color">{{dateFormat2(editorForm.adStartEnd)}}</span>
          </el-form-item>
          <el-form-item :label="$t('advert.contentImg')">
            <!--<span class="grey_color">{{editorForm.adTitle}}</span>-->
            <img :src="imageUrl + editorForm.adImgurl" width="100%" height="auto" />
          </el-form-item>

          <el-form-item :label="$t('advert.isPass')" prop="resource">
            <el-radio-group v-model="isAble">
              <el-radio label="1">{{$t('advert.pass')}}</el-radio>
              <el-radio label="0">{{$t('advert.notPass')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="isAble === '0'" :label="$t('advert.refusal')">
            <el-input v-model="refuse_reason"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="dialogFormVisible = false">{{$t('mao_global.btn.cancel')}}</el-button>
            <el-button type="primary" @click="sbIsAble">{{$t('mao_global.btn.ok')}}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>

</template>
<style scoped>
  .grey_color {
    color:grey;
  }
</style>
<script>
  import axios from 'axios'
  import mm from 'moment'
  import { baseurl,url } from '../../api/url'
  export default{
    data(){
      return {
        // 是否通过   1 通过   0拒绝
        isAble: '1',
      	adId: this.$route.params.id,
        editorForm: {},
        adTypeList: [],
        loading: true,
        imageUrl: url,
        // 拒绝理由
        refuse_reason: '',
      }
    },
    computed: {
    },
    mounted(){
    	var that = this

      that.fetchData()

      that.fetchTypeList()
    },
    methods:{
      // 提交审核结果
      sbIsAble () {
        var that = this

        var data = {
          ad_id: that.editorForm['adId'],
          ad_status: 2,
          refuse_reason: ''
        }

        if (that.isAble === '0') {
          if (!that.refuse_reason || that.refuse_reason === "" ) {
            that.$message.error(this.$t('mao_global.tip.groundsForRefusal'))
            return false
          }

          data['refuse_reason'] = that.refuse_reason
          data['ad_status'] = 3
        }

        axios.post(`${baseurl}/admanage/examine.do`,data).then(res=>{
          that.$message(this.$t('app_vlsuccess'))
          that.fetchData()
          that.dialogFormVisible = false
          that.$router.push({path: '/examine-list'})
        })
      },
      dateFormat2 (date) {
        return mm(date).format('YYYY-MM-DD')
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD')
      },
      fetchTypeList () {
        var that = this
        axios.post(`${baseurl}/adType/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.adTypeList = res.data.data
        })
      },
    	fetchData () {
    		var that = this
        axios.post(`${baseurl}/advertisement/detail.do`,{'id':that.adId}).then(res=>{
          that.editorForm = res.data.data;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// examine_detail.vue?5a408e42